import BaseModel from "./BaseModel";
import BaseObject from "./BaseObject";

/** Suchmodus: nach Name, nach Tag oder in beiden (All). */
export type MatchMode = "Name" | "Tag" | "All";

/**
 * Konfiguration für einen Spaltenfilter in Tabellen-Headern (z. B. Parent-/Großeltern-Auswahl).
 * Wird für Parent- und Grandparent-Spalte in UniversalObjectTable verwendet.
 */
export default class ColumnFilter extends BaseObject {
  get className() {
    return "ColumnFilter"; // no itx
  }

  options: Array<string> | undefined;

  /** Aktueller Wert (z. B. ausgewählte Parent-ID). */
  filterExpression: string = "";
  matchMode: MatchMode = "All"; // no itx

  active: boolean = true;

  isFullTagFilter: boolean = false;

  getOptions?: () => string[];

  constructor(
    init?: Partial<
      Pick<ColumnFilter, "options" | "filterExpression" | "onChange" | "isFullTagFilter" | "matchMode" | "active"> // no itx
    >,
  ) {
    super({}, undefined);

    if (init) {
      if (init.options !== undefined) this.options = init.options;
      if (init.filterExpression !== undefined) this.filterExpression = init.filterExpression;
      if (init.onChange !== undefined) this.onChange = init.onChange;
      if (init.isFullTagFilter !== undefined) this.isFullTagFilter = init.isFullTagFilter;
      if (init.matchMode !== undefined) this.matchMode = init.matchMode;
      if (init.active !== undefined) this.active = init.active;
    }
  }

  evaluate(object: BaseModel): boolean {
    if (this.filterExpression) {
      const vLower = this.filterExpression.toLocaleLowerCase();
      let res = false;
      if (this.matchMode === "Tag" || this.matchMode === "All") {
        if (this.isFullTagFilter) {
          res = object.fullTag.toLocaleLowerCase().indexOf(vLower) >= 0;
        } else {
          res = object.tag.toLocaleLowerCase().indexOf(vLower) >= 0;
        }
      }
      if (this.matchMode === "Name" || this.matchMode === "All") {
        res ||= object.name.toLocaleLowerCase().indexOf(vLower) >= 0;
      }
      return res;
    }

    return true;
  }
}
